export const PROMOTE_APP_TRACK_NAME = 'promote-app-banner';
